import { render, staticRenderFns } from "./TextRowComponent.vue?vue&type=template&id=3f58861c&scoped=true"
import script from "./TextRowComponent.vue?vue&type=script&lang=js"
export * from "./TextRowComponent.vue?vue&type=script&lang=js"
import style0 from "./TextRowComponent.vue?vue&type=style&index=0&id=3f58861c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58861c",
  null
  
)

export default component.exports